<template>
  <div>
    <LocationPermissionModal :show="showLocationPermissionModal" :permissionStatus="locationStore.permissionStatus" @request-permission="handleLocationPermissionRequest" @close="showLocationPermissionModal = false" />

    <!-- <Toaster richColors closeButton position="top-right" /> -->
    <Toaster
      position="top-right"
      :toastOptions="{
        closeButton: true,
        duration: 6000,
        classes: {
          toast: 'bg-white/70 backdrop-blur-sm border border-white text-slate-800 rounded-lg px-4 py-3 shadow-md text-sm',
          closeButton: '!text-slate-800',
          success: '!text-green-600 !bg-green-50/70',
          error: '!text-red-600 !bg-red-50/70',
          warning: '!text-yellow-600 !bg-yellow-50/70',
          info: '!text-blue-600 !bg-blue-50/70',
        },
      }">
      <template #loading-icon>
        <Icon name="svg-spinners:180-ring" class="w-4 h-4" />
      </template>
    </Toaster>

    <!-- System Banners - Fixed Position -->
    <SystemBanner />

    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>
<script setup>
import { useLocationStore } from "@/stores/location"
import { usePreferencesStore } from "@/stores/preferences"

const loading = ref(true)
const { requestLocationPermission } = useLocationTracker()
const showLocationPermissionModal = ref(false)
const locationStore = useLocationStore()
const preferencesStore = usePreferencesStore()

const handleLocationPermissionRequest = async () => {
  const result = await requestLocationPermission()
  // console.log(result)
}

watch(
  () => locationStore.permissionStatus,
  (newStatus) => {
    if (newStatus === "prompt" || newStatus === "denied") {
      showLocationPermissionModal.value = true
    }
  }
)

onMounted(async () => {
  try {
    const route = useRoute()
    const isAuthPage = route.path.startsWith("/auth")

    const res = await useAuthStore().checkAuth()

    // Initialize user preferences and exchange rates
    // Skip on auth pages to avoid 401 redirects
    if (res && !res.error && !isAuthPage) {
      try {
        await Promise.all([preferencesStore.fetchPreferences(), preferencesStore.fetchExchangeRates()])
      } catch (error) {
        console.error("Failed to load preferences:", error)
      }
    }

    if (res instanceof Error && res.message.includes("Network Error")) {
      const { $toast } = useNuxtApp()
      $toast.error("Please check your internet connection and try again")
    }
  } catch (error) {
    console.error(error)
  } finally {
    loading.value = false
  }
})
</script>
